import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem('token');

  if (!token) {
    // 将用户重定向到登录页面，但保存他们尝试访问的页面
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  

  return <>{children}</>;
};

export default PrivateRoute; 